import { useEffect, useRef } from 'react';
/** This hook automatically saves changes after a specified interval */

const useAutoSave = (hasUnsavedChanges: boolean, intervalTime: any, autoSaveFunction: () => void) => {
  const autoSaveTimerRef = useRef<NodeJS.Timeout | null>(null);
  const AUTOSAVE_INTERVAL = intervalTime; //5 * 60 * 1000; // 5 minutes in milliseconds

  // Set up auto-save timer
  useEffect(() => {
    // Function to handle the auto-save check
    const checkAndAutoSave = () => {
      if (hasUnsavedChanges) {
        console.log(`Auto-saving after ${intervalTime} milliseconds`);
        autoSaveFunction();
      }

      // Always set up next check regardless of current state
      autoSaveTimerRef.current = setTimeout(checkAndAutoSave, AUTOSAVE_INTERVAL);
    };

    // Clear any existing timer when component mounts or dependencies change
    if (autoSaveTimerRef.current) {
      clearTimeout(autoSaveTimerRef.current);
    }

    // Initialize the timer
    autoSaveTimerRef.current = setTimeout(checkAndAutoSave, AUTOSAVE_INTERVAL);

    // Cleanup on unmount
    return () => {
      if (autoSaveTimerRef.current) {
        clearTimeout(autoSaveTimerRef.current);
        autoSaveTimerRef.current = null;
      }
    };
  }, [hasUnsavedChanges, autoSaveFunction]);
};

export default useAutoSave;
